module.exports = __webpack_public_path__ + "static/news5pic1-f6a2ba860b569d9b3699d77bca559ba7.jpg";